import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
// ErrorBoundary global : une erreur de rendu affiche un ecran "Recharger" propre
// au lieu d'un ecran blanc total (cf. src/ErrorBoundary.jsx).
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Enregistre le Service Worker pour permettre l'installation PWA
// (Chrome Android, Play Store TWA) et un fonctionnement dégradé hors-ligne.
// Doit être appelé APRÈS le render initial pour ne pas bloquer le 1er paint.
serviceWorkerRegistration.register();
